import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { InsightContentSettingType } from 'components/insightContent/types'
import { PostTypeGroup } from 'enums'
import RunSearchEffect from '../share/RunSearchEffect'
import InsightTable from '../share/InsightTable'

const Reposts = ({ detailSetting }: { detailSetting: InsightContentSettingType }) => (
  <UnexpectedErrorBoundary>
    <RunSearchEffect postType={PostTypeGroup.REPOSTS} detailSetting={detailSetting}>
      <InsightTable postType={PostTypeGroup.REPOSTS} />
    </RunSearchEffect>
  </UnexpectedErrorBoundary>
)

export default Reposts
